import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import Box from '@mui/material/Box';
const EmployeeCarsoul = dynamic(() => import('@/components/Ui-components/employeeCarsoul'), {ssr: false});

const EmployeeFeedback = (props: any) => {
    const {carsoulheading, carsoulsubheading} = props;

    return (
        <Box className="employee-feedback-wrapper">
            <Box className="spectrum-header-wrapper solutions">
                <MUITypography className="spectrum-heading top-space color-black">{carsoulheading}</MUITypography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                {carsoulsubheading && (
                    <Box className="sub-heading-box">
                        <MUITypography className="spectrum-sub-heading color-black">{carsoulsubheading}</MUITypography>
                    </Box>
                )}
            </Box>
            <MUIContainer maxWidth="lg" className="top-spacing">
                <EmployeeCarsoul />
            </MUIContainer>
        </Box>
    );
};

export default memo(EmployeeFeedback);
